import service from '@/services/facturacion/factura'

const getDefaultState = () => ({
  factura: {
    fechaEmisionOriginal: null,
    original: null,

    medioPago: [{}],
    pagaCon: '',
    detalleServicio: {
      lineaDetalle: []
    },
    otrosCargos: [],
    resumenFactura: {
      totalDescuentos: 0,
      totalImpuesto: 0,
      totalServGravados: 0,
      totalServExonerado: 0,
      totalMercanciasGravadas: 0,
      totalMercExonerada: 0,
      totalGravado: 0,
      totalExonerado: 0,
      totalVenta: 0,
      totalVentaNeta: 0,
      // const TotalIVADevuelto : No aplica en esta version.,
      totalComprobante: 0
    },
    informacionReferencia: []
  },

  facturas: [],
  pageInfo: {},
  currentRow: null,

  totalGeneral: [
    {
      documentos: 0,
      clientes: 0,
      totalComprobante: 0.0,
      totalVentaNeta: 0.0,
      totalImpuesto: 0.0
    }
  ],

  totalRegistros: 0,

  saved: 'null'
})

export const state = () => getDefaultState()

export const mutations = {
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  SET_ROW: (state, row) => (state.currentRow = row),
  SET_FULL_DOCUMENTO: (state, obj) => {
    state.factura = obj
  },
  SET_FACTURAS: (state, obj) => {
    state.facturas = obj.feed
    // state.pageInfo = obj.pageInfo
  },
  CLEAN_FACTURA: state => {
    state.factura = {
      fechaEmisionOriginal: null,
      original: null,
      medioPago: state.factura.medioPago, // mantiene el valor de la factura anterior
      pagaCon: '',
      detalleServicio: {
        lineaDetalle: []
      },
      otrosCargos: [],
      resumenFactura: {
        totalDescuentos: 0,
        totalImpuesto: 0,
        totalServGravados: 0,
        totalServExonerado: 0,
        totalMercanciasGravadas: 0,
        totalMercExonerada: 0,
        totalGravado: 0,
        totalExonerado: 0,
        totalVenta: 0,
        totalVentaNeta: 0,
        // const TotalIVADevuelto : No aplica en esta version.,
        totalComprobante: 0
      },
      informacionReferencia: [],
      otros: null
    }
    // state.exoneracion = null

    state.saved = true
  }
}
export const actions = {
  resetList: ({ state }) => {
    state.facturas = []
    state.pageInfo = {}
    state.totalRegistros = 0
  },

  readByDateRange: async ({ commit, dispatch, rootGetters }, { inicio, final }) => {
    await dispatch('resetList')

    return service.readBulkByDateRange(await rootGetters['facturacion/emisorStore/get_Id'], inicio, final).then(result => commit('SET_FACTURAS', result))
  },
  readById: async ({ commit, getters }, { id, forced }) => {
    // if (doc?.clave && !forced) {
    //   commit('SET_DOCUMENTO', { storeList, obj: doc })
    //   console.log('Documento from cache ⏩')
    //   return true
    // }

    return service.readBulkById(id).then(result => {
      commit('SET_FULL_DOCUMENTO', result)

      console.log('Documento from DB 😫')

      return true
    })
  },
  async createNotaCredito({ state, dispatch }, { razon, _id }) {
    return service.createNotaCreditoBulk(_id, razon).then(result => {
      if (state.factura.cajaSesion) {
        dispatch(
          'cajas/movimientoStore/create',
          {
            sesion: { _id: state.factura.cajaSesion._id },
            tipo: 'CANCELACION_VENTA',
            montoIngreso: 0,
            montoEgreso: state.factura.resumenFactura.totalComprobante,
            medioPago: state.factura.medioPago[0].annotation.split(' ')[0].toUpperCase(),
            detalle: `Anulada por el administrador. Razón: ${razon}`
          },
          { root: true }
        )
      }

      const tempFact = state.facturas.find(e => e.id === _id)

      if (tempFact) tempFact.state = false

      return result
    })
  }
}
